import React from "react";
import { Snackbar, Alert } from "@mui/material";

// Shared so save/delete failures surface the same way everywhere. `value` is
// null when nothing is showing, otherwise { severity, text }.
const Toast = ({ value, onClose, autoHideDuration = 5000 }) => (
  <Snackbar
    open={value != null}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
  >
    <Alert
      severity={value?.severity ?? "success"}
      variant="filled"
      onClose={onClose}
      sx={{ fontSize: 13, borderRadius: "8px" }}
    >
      {value?.text}
    </Alert>
  </Snackbar>
);

export { Toast };
